import { CREATE_CONTACT_US } from "../gql/StaticPagesQueris";
import SuccsssesIcon from "@/assets/images/pictures/succsses.svg?inline";
import CloseIcon from "@/assets/images/icons/close.svg?inline";

import {
  required,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";

export default {
  name: "contact_us",

  data() {
    return {
      name: "",
      email: "",
      message: "",
      subject: "",
      phone: "",

      submitStatus: null
    };
  },

  validations: {
    name: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(64)
    },

    email: {
      required,
      email,
      maxLength: maxLength(256)
    },

    subject: {
      minLength: minLength(2),
      maxLength: maxLength(126)
    },

    message: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(500)
    }
  },

  props: {
    propertyReport: {
      type: String,
      default: ""
    }
  },

  mounted: function() {
    if (this.propertyReport) {
      this.message = `${process.env.VUE_APP_BASE_URL}${
        this.$router.resolve({
          name: "property",
          params: { id: this.propertyReport }
        }).href
      }`;
    }
  },

  methods: {
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        // do your submit logic here
        this.submitStatus = "PENDING";

        const newContact = {
          name: this.name,
          email: this.email,
          subject: this.subject,
          phone: this.phone,
          message: this.message
        };

        this.$apollo
          .mutate({
            mutation: CREATE_CONTACT_US,

            variables: {
              name: newContact.name,
              email: newContact.email,
              messageSubject: newContact.subject,
              phone: newContact.phone,
              message: newContact.message
            }
          })
          .then(data => {
            this.submitStatus = "OK";

            this.$v.$reset();

            this.name = "";
            this.email = "";
            this.subject = "";
            this.phone = "";
            this.message = "";

            this.$refs.succssesModal.show();
          })
          .catch(error => {
            // Error
            this.submitStatus = "ERROR";

            this.name = newContact.name;
            this.email = newContact.email;
            this.subject = newContact.subject;
            this.phone = newContact.phone;
            this.message = newContact.message;
          });
      }
    },

    hideModal() {
      this.$refs.succssesModal.hide();
    }
  },

  components: {
    SuccsssesIcon,
    CloseIcon
  }
};
